
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("adRF9", function(module, exports) {
$parcel$export(module.exports, "SMART_LINK_DRAG_TYPES", () => $6d8149569a4282c1$export$89741becde3d0e54);
$parcel$export(module.exports, "SMART_LINK_APPEARANCE", () => $6d8149569a4282c1$export$a4a3cf1d43312764);
$parcel$export(module.exports, "SmartLinkDraggable", () => $6d8149569a4282c1$export$c67c8f76ce4436c);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $6Zi52 = parcelRequire("6Zi52");

var $9b5Ea = parcelRequire("9b5Ea");

var $fnEFU = parcelRequire("fnEFU");

var $guSlZ = parcelRequire("guSlZ");

var $c8sLM = parcelRequire("c8sLM");

var $gd0xB = parcelRequire("gd0xB");

var $l2xrI = parcelRequire("l2xrI");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $jt4qp = parcelRequire("jt4qp");
var $6d8149569a4282c1$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $6d8149569a4282c1$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $6d8149569a4282c1$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
}
function $6d8149569a4282c1$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $6d8149569a4282c1$var$idleState = {
    type: 'idle'
};
const $6d8149569a4282c1$var$draggingState = {
    type: 'dragging'
};
const $6d8149569a4282c1$var$styles = {
    preview: "_1reo15vq _18m915vq _2rko12b0 _1rjc1b66 _18zru2gc _1dqonqa1 _1h6d1l7x _bfhkvuon _p12fgx0z _16qs130s",
    previewText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    draggableBlock: "_80om1qgj"
};
const $6d8149569a4282c1$var$previewIconStyles = null;
const $6d8149569a4282c1$var$draggableInlineStyles = null;
function $6d8149569a4282c1$var$SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        xcss: $6d8149569a4282c1$var$styles.preview,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $i3riz.Inline), {
            alignBlock: "center",
            space: "space.075",
            children: [
                iconUrl && /*#__PURE__*/ (0, $3LM7S.jsx)("img", {
                    src: iconUrl,
                    alt: "",
                    className: (0, $2R2iS.default)([
                        "_1bsbpxbi _4t3ipxbi _1o9zidpf"
                    ])
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    as: "span",
                    xcss: $6d8149569a4282c1$var$styles.previewText,
                    children: title || url
                })
            ]
        })
    });
}
function $6d8149569a4282c1$var$getIconUrl(details) {
    var _details$data, _details$meta;
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && typeof (details === null || details === void 0 || (_details$data = details.data) === null || _details$data === void 0 ? void 0 : _details$data.icon) === 'string') return details.data.icon;
    const objectIconUrl = (0, $jt4qp.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
    // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details !== null && details !== void 0 && details.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
    // Fallback to provider/generator icon (product logo)
    if (typeof (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.generator) === null || _details$meta === void 0 || (_details$meta = _details$meta.icon) === null || _details$meta === void 0 ? void 0 : _details$meta.url) === 'string') return details.meta.generator.icon.url;
    return undefined;
}
/**
 * Inner component that handles the actual drag behavior.
 * Must be rendered within a SmartCardProvider context.
 */ function $6d8149569a4282c1$var$SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $fc4bM.useRef)(null);
    const { store: store } = (0, $fnEFU.useSmartLinkContext)();
    const [state, setState] = (0, $fc4bM.useState)($6d8149569a4282c1$var$idleState);
    // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $fc4bM.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState === null || cardState === void 0 ? void 0 : cardState.details;
                const title = propTitle || (0, $9b5Ea.extractSmartLinkTitle)(details);
                const iconUrl = $6d8149569a4282c1$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState = store.getState()[url];
                const details = cardState === null || cardState === void 0 ? void 0 : cardState.details;
                const title = propTitle || (0, $9b5Ea.extractSmartLinkTitle)(details);
                const iconUrl = $6d8149569a4282c1$var$getIconUrl(details);
                (0, $l2xrI.setCustomNativeDragPreview)({
                    getOffset: (0, $gd0xB.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title,
                            iconUrl: iconUrl
                        });
                        return ()=>setState($6d8149569a4282c1$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($6d8149569a4282c1$var$draggingState),
            onDrop: ()=>setState($6d8149569a4282c1$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $fc4bM.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]';
        // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null;
        // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $6Zi52.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                var _cleanupDraggable;
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && (selectionAtPointerDown === null || selectionAtPointerDown === void 0 ? void 0 : selectionAtPointerDown.type) === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                (_cleanupDraggable = cleanupDraggable) === null || _cleanupDraggable === void 0 || _cleanupDraggable();
                const target = event.target;
                // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = (targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest(inlineCardRootSelector)) ?? null;
                    const closestInlineAnchor = (targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest('a[href], [data-smart-element-link]')) ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $c8sLM.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            var _cleanupDraggable2, _observer;
            (_cleanupDraggable2 = cleanupDraggable) === null || _cleanupDraggable2 === void 0 || _cleanupDraggable2();
            unbindPointerDown();
            (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).createPortal(/*#__PURE__*/ (0, $3LM7S.jsx)($6d8149569a4282c1$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null;
    // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
                className: (0, $2R2iS.default)([
                    "_80om1qgj _1e0c1nu9"
                ]),
                children: children
            }),
            preview
        ]
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                ref: ref,
                xcss: $6d8149569a4282c1$var$styles.draggableBlock,
                testId: "smart-link-draggable-block",
                children: children
            }),
            preview
        ]
    });
}
function $6d8149569a4282c1$export$c67c8f76ce4436c({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $guSlZ.isSafeUrl)(url)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($6d8149569a4282c1$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget,
        children: children
    });
}

});
parcelRegister("gd0xB", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => $fc4b45ab1e28cd8f$export$427e20518819fabc);

var $9QxPo = parcelRequire("9QxPo");

var $2xHn1 = parcelRequire("2xHn1");

var $5kqph = parcelRequire("5kqph");
function $fc4b45ab1e28cd8f$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
     * **Approach: transparent borders.**
     *
     * The only reliable cross browser technique found to push a
     * drag preview away from the cursor is to use transparent borders on the container.
     *
     * **🙅📱 Not pushing the preview away on touch devices**
     *
     * _On iOS_
     *
     * Safari will set the transparent border color to be black
     *
     * `iOS@18.4.1` on May 7th 2025:
     * - If you set the background color on the `container` the border color will be that
     * - Setting a transparent background color on the `container` still results in a
     *   black border
     * - The `<body>` text or background color does not change the black border color
     *
     * While dragging, the drag preview will shift under the center of the users pointer.
     * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
     * to be under the middle of the users pointer.
     *
     * _On Android_
     *
     * Chrome will put the center of the drag preview under the users pointer immediately.
     *
     * Tested on `Chrome@137` on `Android 14` on June 20th 2025
     *
     * _What we do_
     *
     * We don't add the transparent border
     *
     * - Avoid the black color on iOS
     * - It isn't needed on Android anyway as the preview will be under the center
     *   of the users pointer
     *
     * We put the center of the drag preview under the users pointer
     *
     * - Avoids the drag preview quickly moving from a top corner to be centered under
     *   the users pointer on iOS
     * - It will be under the center on Android no matter what we do
     *
     * We previously had a isTouchDevice() check, but it felt safer for now
     * to have a more targeted check, as these are the devices that have been
     * tested on.
     */ if ((0, $2xHn1.isSafariOnIOS)() || (0, $9QxPo.isAndroid)()) return (0, $5kqph.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("2xHn1", function(module, exports) {
$parcel$export(module.exports, "isSafariOnIOS", () => $7e3d7095af845a53$export$52fc40c68fea4952);

var $9Z0cf = parcelRequire("9Z0cf");

var $9bmoJ = parcelRequire("9bmoJ");
const $7e3d7095af845a53$export$52fc40c68fea4952 = (0, $9Z0cf.once)(function isSafariOnIOS() {
    return (0, $9bmoJ.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("5kqph", function(module, exports) {
$parcel$export(module.exports, "centerUnderPointer", () => $f4edf7242275106c$export$81d8e72a15eef435);
const $f4edf7242275106c$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});



parcelRegister("awnH2", function(module, exports) {
$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $95f83cae391a9517$export$f386473e8f104bcb);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

const $95f83cae391a9517$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>(parcelRequire("gf2UU")));
const $95f83cae391a9517$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($95f83cae391a9517$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });

});
parcelRegister("gf2UU", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8P1qy").then(()=>parcelRequire('35kgS'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});




parcelRegister("dIMFD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3afa7e82a84c6150$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $801jp = parcelRequire("801jp");

var $014x6 = parcelRequire("014x6");

var $5uAqu = parcelRequire("5uAqu");

var $hQjsl = parcelRequire("hQjsl");

var $4seZv = parcelRequire("4seZv");

var $bcN2K = parcelRequire("bcN2K");

var $bQrkt = parcelRequire("bQrkt");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $aEmSo = parcelRequire("aEmSo");

var $fzU5N = parcelRequire("fzU5N");
var $3LeME = parcelRequire("3LeME");

var $Ev44L = parcelRequire("Ev44L");
function $3afa7e82a84c6150$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $3afa7e82a84c6150$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $014x6.akEditorFullPageDefaultFontSize)}px) - ${(0, $014x6.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $3afa7e82a84c6150$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $3afa7e82a84c6150$var$iconWrapperStyles = (0, $kig2V.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $3afa7e82a84c6150$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $3afa7e82a84c6150$var$linkStylesCommon = (0, $kig2V.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $3afa7e82a84c6150$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $3afa7e82a84c6150$var$ICON_WIDTH = 16;
const $3afa7e82a84c6150$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $3afa7e82a84c6150$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $801jp.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $fzU5N.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $3afa7e82a84c6150$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const containerRef = (0, $fc4bM.useRef)(null);
    const hoverLinkButtonRef = (0, $fc4bM.useRef)(null);
    const hiddenTextRef = (0, $fc4bM.useRef)(null);
    const [showLabel, setShowLabel] = (0, $fc4bM.useState)(true);
    const [isHovered, setHovered] = (0, $fc4bM.useState)(false);
    const openTextWidthRef = (0, $fc4bM.useRef)(null);
    const regularPadding = $3afa7e82a84c6150$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $fc4bM.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $bcN2K.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $3afa7e82a84c6150$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _containerRef$current, _hoverLinkButtonRef$c;
        if (!isVisible || !isHovered) return;
        const cardWidth = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
        const openButtonWidth = (_hoverLinkButtonRef$c = hoverLinkButtonRef.current) === null || _hoverLinkButtonRef$c === void 0 ? void 0 : _hoverLinkButtonRef$c.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $3afa7e82a84c6150$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $3afa7e82a84c6150$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $3afa7e82a84c6150$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $3afa7e82a84c6150$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $3afa7e82a84c6150$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $3LeME.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(destinationUrl ?? url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $3LeME.INPUT_METHOD).BUTTON);
    };
    const label = showPanelButton ? formatMessage((0, $Ev44L.messages).previewButtonTitle) : formatMessage((0, $Ev44L.messages).openButtonTitle);
    let icon = null;
    if (showPanelButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4seZv))), {
        label: ""
    });
    else if (showPanelButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uAqu))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hQjsl))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        ref: containerRef,
        css: $3afa7e82a84c6150$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: $3afa7e82a84c6150$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4T8rw.Text), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $jctmk.jsx)((0, $bQrkt.Anchor), {
        ref: hoverLinkButtonRef,
        xcss: $3afa7e82a84c6150$var$linkStylesCommon,
        href: destinationUrl ?? url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        xcss: $3afa7e82a84c6150$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $jctmk.jsx)((0, $4T8rw.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $3afa7e82a84c6150$export$2e2bcd8739ae039 = $3afa7e82a84c6150$var$HoverLinkOverlay;

});
parcelRegister("fzU5N", function(module, exports) {
$parcel$export(module.exports, "buildEditLinkPayload", () => $88918803e2706523$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $88918803e2706523$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildVisitedNonHyperLinkPayload", () => $88918803e2706523$export$4c5e2a0406e7eae8);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $88918803e2706523$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $88918803e2706523$export$aab75a08bdd88be4);

var $3LeME = parcelRequire("3LeME");
const $88918803e2706523$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $3LeME.ACTION).CLICKED,
        actionSubject: type === (0, $3LeME.ACTION_SUBJECT_ID).HYPERLINK ? (0, $3LeME.ACTION_SUBJECT).HYPERLINK : (0, $3LeME.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $3LeME.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $3LeME.EVENT_TYPE).UI
    };
};
const $88918803e2706523$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $3LeME.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $3LeME.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $3LeME.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $88918803e2706523$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $3LeME.ACTION_SUBJECT_ID).HYPERLINK ? $88918803e2706523$var$buildVisitedHyperLinkPayload() : $88918803e2706523$export$4c5e2a0406e7eae8(type, (0, $3LeME.INPUT_METHOD).TOOLBAR);
};
const $88918803e2706523$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $3LeME.ACTION).VISITED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $3LeME.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    };
};
const $88918803e2706523$export$4c5e2a0406e7eae8 = (type, inputMethod, resolvedAttributes)=>{
    return {
        action: (0, $3LeME.ACTION).VISITED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod,
            ...resolvedAttributes && {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            }
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    };
};
const $88918803e2706523$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $3LeME.ACTION).CLICKED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $3LeME.INPUT_METHOD).TOOLBAR,
            display: $88918803e2706523$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $3LeME.EVENT_TYPE).UI
    };
};
const $88918803e2706523$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $3LeME.ACTION).UNLINK,
        actionSubject: type === (0, $3LeME.ACTION_SUBJECT_ID).HYPERLINK ? (0, $3LeME.ACTION_SUBJECT).HYPERLINK : (0, $3LeME.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $3LeME.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $3LeME.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    };
};

});

parcelRegister("Ev44L", function(module, exports) {
$parcel$export(module.exports, "messages", () => $021d33d322e937cf$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $021d33d322e937cf$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Label for a toolbar option that changes a smart link to display inline, showing only the link title as a compact inline element within the text.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Label for a toolbar option that changes a smart link to display as an embedded object, showing a rich preview of the linked content.'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'The text is shown as a title for the floating toolbar when a user selects an inline card or smart link in the editor, providing options to change the card display type.'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    panelButtonTitle: {
        id: 'fabric.editor.panelButtonTitle',
        defaultMessage: 'Panel',
        description: 'Title for a button that opens side panel when clicked.'
    },
    previewButtonTitle: {
        id: 'fabric.editor.previewButtonTitle',
        defaultMessage: 'Preview',
        description: 'Title for a button that when clicked opens a preview modal or a preview panel.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    embedToBlockCardWarning: {
        id: 'fabric.editor.embedToBlockCardWarning',
        defaultMessage: 'Displays as a card on small screens',
        description: 'Warning message to show the user that embed card will be displayed as a block card on small screens.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Accessible label for an icon button in the smart link toolbar that expands a dropdown menu containing additional editing options for the link.'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Label for a button inside the smart link edit dropdown menu that opens the link editing interface to modify the URL or display text.'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Title shown as a quick insert option for adding a Jira Issues datasource table that displays live Jira issue data in the editor.'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Description text shown beneath the Jira Issues option in the quick insert menu, explaining what data the datasource will display when inserted.'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Display filtered Assets objects',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    // Remove when cleaning up platform_editor_slash_command
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceList: {
        id: 'fabric.editor.datasource.confluenceList',
        defaultMessage: 'Confluence list',
        description: 'Title shown for Confluence Search datasource in the Data and charts section of the editor slash command menu'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Display filtered Confluence search results',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira work items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Display filtered Jira work items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});


parcelRegister("868c8", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkActions", () => $d1ba1f2efe28d364$export$a95296ded9241771);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $fnEFU = parcelRequire("fnEFU");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $fVrlX = parcelRequire("fVrlX");

var $7EFx4 = parcelRequire("7EFx4");

var $5knQT = parcelRequire("5knQT");

var $V9qe1 = parcelRequire("V9qe1");

var $ewFKq = parcelRequire("ewFKq");

var $iB1w3 = parcelRequire("iB1w3");

var $cA6hx = parcelRequire("cA6hx");

var $fypiH = parcelRequire("fypiH");

var $jpYbX = parcelRequire("jpYbX");

var $fzYCU = parcelRequire("fzYCU");
function $d1ba1f2efe28d364$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $fc4bM.useMemo)(()=>(0, $eUgRu.default)(), []);
    const linkState = (0, $fzYCU.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $fnEFU.useSmartLinkContext)();
    const invokeClientAction = (0, $cA6hx.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $fypiH.default)();
    const appendCrossProductAnalyticsParams = (0, $jpYbX.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    if ((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide)) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $7EFx4.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $iB1w3.toAction)(downloadActionProps, invokeClientAction, (0, $ewFKq.messages).download, 'download-content'));
        const viewActionProps = (0, $V9qe1.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (viewActionProps) actions.push((0, $iB1w3.toAction)(viewActionProps, invokeClientAction, (0, $ewFKq.messages).view, 'view-content'));
        const previewActionProps = (0, $5knQT.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (previewActionProps) actions.push((0, $iB1w3.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $ewFKq.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}

});
parcelRegister("iB1w3", function(module, exports) {
$parcel$export(module.exports, "toAction", () => $c729ad6553dd978e$export$9d52be0dab870c7);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
const $c729ad6553dd978e$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), message),
        invoke: ()=>invokeClientAction(action)
    };
};

});



//# sourceMappingURL=shared.1662f58c.js.map
